import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import axiosClient from "../../api/axiosClient";
import "./SignIn.scss";
import headerLogo from "../../assets/Icons/header.png";
import { trackEvent } from "../../mixpanel";

interface SignInProps {
  setIsAuthenticated: (value: boolean) => void;
  setNeedsOTPVerification: (value: boolean) => void;
  setUserEmail: (value: string) => void;
}

function SignIn({
  setIsAuthenticated,
  setNeedsOTPVerification,
  setUserEmail,
}: SignInProps) {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleSignIn = async (e: React.FormEvent) => {
    trackEvent("SIGN_IN_CLICKED");
    e.preventDefault();
    setError("");
    setIsLoading(true);

    try {
      const response = await axiosClient.post("magic-login", {
        email: email,
      });

      // On successful API call, redirect to OTP screen
      if (response.data) {
        setUserEmail(email);
        setNeedsOTPVerification(true);
        navigate("/verify-otp");
      }
    } catch (err: any) {
      console.error("Error signing in:", err);
      if (err.response?.data?.error.includes("User does not exist")) {
        trackEvent("SIGN_IN_FAILED_USER_NOT_EXIST");
        setError(
          "This account does not have the access privileges. Please reach out to your admin team or contact support at hello@yetimyfriend.com",
        );
        return;
      }
      setError(
        err.response?.data?.error || "Failed to sign in. Please try again.",
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="signin-container">
      <div className="signin-content">
        <div className="logo-container">
          <img
            src={headerLogo}
            alt="Teacher Dashboard Logo"
            className="logo-image"
          />
        </div>

        <h1 className="signin-main-title">Champion Teacher Workspace</h1>

        <div className="signin-form-wrapper">
          <h2 className="signin-heading">Let's sign back in!</h2>

          <form onSubmit={handleSignIn} className="signin-form">
            <div className="input-wrapper">
              <input
                type="email"
                placeholder="School email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="email-input"
                required
              />
            </div>

            {error && <div className="error-message">{error}</div>}

            <button
              type="submit"
              className="continue-button"
              disabled={isLoading}
            >
              {isLoading ? "Signing in..." : "Continue"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

export default SignIn;
